import { useCallback, useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';

import { debounce } from 'lodash';
import Form from 'react-bootstrap/Form';
import { EqualHeight } from 'react-equal-height';
import NewsController from '../../apis/controller/news.controller';
import { dateFormat } from '../../Components/helper/date';
import { charLimit, stripTags } from '../../Components/helper/General';
import { renderImage } from '../../Components/helper/image';
import PageTitle from '../../Components/PageTitle';

function NewsPage() {
    const [keyword, setSearch] = useState('');
    const [news, setNews] = useState();
    const [idArray, setIdarray] = useState([]);
    const [newsCategory, setNewsCategory] = useState();
    const [loader, setLoader] = useState(false);
    const [page, setPage] = useState(1);
    const [pagination, setPagination] = useState(true);
    const [breadCrumbs, setBreadcrumbs] = useState();

    let param = useParams();
    useEffect(() => {
        window.scrollTo(0, 0);
        initPage();
    }, []);

    useEffect(() => {
        setPagination(pagination);
    }, [pagination]);

    const initPage = async () => {
        if(param && param.slug){
            let array = []
            array.push(param.slug)
            await getNews('', array, 1);
        }
        else{
            await getNews('', [], 1);
        }
      
        await getNewsCategory();
        window.onscroll = async function (ev) {
            if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight - 100 && document.getElementById('load-more-button')) {
                document.getElementById('load-more-button').click();
            }
        };

        return () => {
            var elem = document.getElementById('load-more-button');
            elem.removeEventListener("click");
            window.onscroll = null;
        }
    }

    const getNews = async (search, data, page = 1) => {
        let post = {
            search: search,
            categories: data ? data : [],
            page: page ? page : 1,
        };

        if (!loader) {
            setLoader(true);
            let response = await new NewsController().newsListing(post);
            if (response && response.status) {
                setBreadcrumbs(response.breadcrumb);
                let list = response.news;
                if (list.length > 0) {
                    if (page === 1) {
                        setNews(list);
                    } else {
                        // console.log('aaaaa');
                        setNews([...news, ...list]);
                    }
                    setPagination(true);
                    setPage(page + 1)
                } else {
                    setPagination(false);
                    if (page === 1) {
                        setNews([]);
                    }
                }
            }
            setLoader(false);
        }
    };

    const getNewsCategory = async () => {
        let res = await new NewsController().newsCategories();
        if (res && res.status) {
            setNewsCategory(res.news);
        }
    };

    const isExist = id => {
        let result = false;
        let myArray = idArray;
        for (let i = 0; i < myArray.length; i++) {
            if (myArray[i] == id) {
                result = true;
                break;
            } else {
                result = false;
            }
        }
        return result;
    };

    const addItem = async (item) => {
        if (isExist(item && item.slug)) {
            var itemIndex = idArray.indexOf(item.slug);
            idArray.splice(itemIndex, 1);
            setIdarray(idArray)
        }
        else {
            idArray.push(item.slug);
            setIdarray(idArray)
        }
        await getNews(keyword, idArray, 1);
        setPage(1)
    };

    const getMore = async () => {
        if (pagination) {
            await getNews(keyword, idArray, page);
        }
    };

    const search = useCallback(debounce(getNews, 1000), []);
    return (
        <>
            {breadCrumbs ? <PageTitle title={breadCrumbs.main_title} image={breadCrumbs.image} /> : null}
            <div className="page_content_section">
                <div className="news_page_section bg-light pt-5 pb-5">
                    <Container>
                        <Row>
                            <Col>
                                <div className="news_page_area">
                                    <Row>
                                        {newsCategory ? <Col xl={4} lg={4} md={5} sm={12} xs={12}>
                                            <div className="news_sidebar pt-md-4 sticky-sm-top ">
                                                <div className="shadowed_whitebox p-3 p-lg-4 newspage_search mb-4">
                                                    <div className="input-group">
                                                        <input type="search" className="form-control" placeholder="Search For..."
                                                            value={keyword}
                                                            onChange={e => {
                                                                setSearch(e.target.value);
                                                                search(e.target.value)
                                                            }}
                                                        />
                                                        <div className="input-group-append">
                                                            <button className="btn btn-outline-secondary" type="button">
                                                                <i className="far fa-search"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <Events /> */}
                                                <div className="shadowed_whitebox p-3 p-lg-4 news_categories mb-4">
                                                    <div className="sidebar_title">
                                                        Categories
                                                        <hr />
                                                    </div>
                                                    <div className='check_boxes'>
                                                        <Form>
                                                            {['checkbox'].map((type) => (
                                                                <div key={`inline-${type}`} className="mb-3">
                                                                    {newsCategory.map((item, index) => (
                                                                        <Form.Check
                                                                            key={index}
                                                                            // inline
                                                                            label={item.title}
                                                                            name="group1"
                                                                            type={type}
                                                                            value={item.slug}
                                                                            id={`inline-${type}${index}`}
                                                                            onClick={() => addItem(item)}
                                                                            defaultChecked={param && param.slug  && param.slug === item.slug ? item.slug : null}
                                                                        />
                                                                    ))}
                                                                    {/* <Form.Check
                                                                    label="2"
                                                                    name="group1"
                                                                    type={type}
                                                                    id={`inline-${type}-2`}
                                                                />
                                                                <Form.Check
                                                                    label="3"
                                                                    type={type}
                                                                    id={`inline-${type}-3`}
                                                                /> */}


                                                                </div>
                                                            ))}
                                                        </Form>
                                                    </div>
                                                    {/* <ul>
                                                        {newsCategory.map((item, index) => (

                                                            <li class={idArray.length > 0 && item.id === idArray[0] ? 'active' : null} key={index} onClick={() => addItem(item, index)}>
                                                                <Link to="#">{item.title}</Link>
                                                            </li>
                                                        ))}
                                                    </ul> */}
                                                </div>
                                            </div>
                                        </Col> : null}
                                        <Col xl={8} lg={8} md={7} sm={12} xs={12}>
                                            {news && news.length > 0 ? <div className="news_listing pt-4">
                                                <EqualHeight>
                                                    <Row>
                                                        {news.map((item, index) => (
                                                            <Col xl={6} lg={6} md={12} sm={6} xs={12}>
                                                                <div key={index} className="news_item">
                                                                    <div className="img_area embed-responsive embed-responsive-4by3">
                                                                        <img src={renderImage(item.image, 'large')} className="embed-responsive-item img-fluid" alt="..." />
                                                                        <div className="upper_img">
                                                                            <div className="secondary_btn">
                                                                                <Link to={`/newsdetail/${item.slug}`
                                                                                }>Read More</Link>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="news_info">
                                                                        {item.categories.map((item, index) => (

                                                                            <div key={index} className="d-flex align-items-center justify-content-between mb-2">
                                                                                <div className="news_catg">
                                                                                    <Link to={`/newsdetail/${item.slug}`}>{item.title}</Link>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                        <h5>
                                                                            <Link to={`/newsdetail/${item.slug}`}>{item.title}</Link>
                                                                        </h5>
                                                                        {/* <div dangerouslySetInnerHTML={{ __html:charLimit(item.description, 150)}} /> */}
                                                                        <p>{charLimit(stripTags(item.description), 150)}</p>
                                                                        <hr />
                                                                        <div className="news_metainfo">
                                                                            <ul>
                                                                                <li>
                                                                                    <i className="far fa-user"></i>
                                                                                    <span>By {item.owner_first_name} {item.owner_last_name}</span>
                                                                                </li>
                                                                                <li>
                                                                                    <i className="far fa-calendar"></i>
                                                                                    <span>{dateFormat(item.created)}</span>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </EqualHeight>
                                            </div> :
                                                <div className="no_data">
                                                    <p> No Data Found</p>
                                                </div>}
                                            <button
                                                style={{ 'width': 0, 'height': 0, 'background': 'transparent', 'position': 'absolute', 'top': '-1000px', 'left': '-1000px' }}
                                                id="load-more-button"
                                                onClick={() => {
                                                    getMore();
                                                }}
                                            ></button>
                                            {/* <div className='secondary_btn mt-2'>
                                                <button
                                                    style={{  'border-radius': '0' , 'margin':'0 auto' , 'textAlign': 'center' ,'display':'block', 'padding':'6px 20px' }}
                                                    id="load-more-button"
                                                    className='btn btn-primary'
                                                    onClick={() => {
                                                        getMore(page);
                                                    }}
                                                >
                                                    View More
                                                </button>
                                            </div> */}
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    );
}

export default NewsPage;
